//import $ from 'jquery';

import { View } from 'backbone';
import template  from 'dashboard/forms/modal/confirm-delete-instance-modal.ejs';
import RestService      from 'RestService.js';
import NotificationService from 'NotificationService.js';
import eventBus  from 'EventBus.js';
import undoService from 'UndoService.js'
import constants from 'Constants.js'
import textConstants from 'TextConstants';
import Spinner from 'spin/spin';

class ConfirmDeleteInstanceModal extends View {

    initialize(opts) {
        this.options = opts || {};
        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;
        this.El = "#confirmDeleteInstanceModal";
        this.fromList = Array.isArray(this.model.get("formInstanceList"));
    
        return this;
    }
    
    removeInstancesFromGrid() {
        const instances = [...this.model.get('formInstances')];
        const allInstances = this.model.get("formInstanceList");
        const deletedInstances = [];
        let index = 0;

        _.each(instances, (instance, i) => {

            if (this.fromList) {
                let rowData = allInstances.filter(item => {
                    return item.id === instance;
                })[0];

                index = $('#formInstancesGrid').getInd(instance);

                deletedInstances.push({data: rowData, index: index});
            }
        });

        //PF-6449 Needs two loops to get the correct indexes of the deleted rows
        _.each(instances, (instance, i) => {
            $('#formInstancesGrid').jqGrid('delRowData', instance);
            $('#formInstancesGrid').trigger('reloadGrid');
            $(`i[data-itemid*='${instance}']`).parent().hide();
        });

        return deletedInstances;
    }

    deleteInstance() {
        const formInstancesXML = this.model.get('formInstancesXML');
        let self = this;

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
    
        RestService.deleteFormInstance(formInstancesXML).then((data) => {
            return (data);
        }).catch((error) => {
            let msg = error || 'Unknown Error';
            NotificationService.error(msg);
            console.log(msg);
            return (error);
        });

        //PF-6449 Allow the service to finish before continuing
        setTimeout(function () {
            const deletedInstances = self.removeInstancesFromGrid();
            undoService.add({
                redo: () => {
                    self.deleteInstance();
                },
                undo: () => {
                    self.restoreInstance(deletedInstances);
                }
            }, textConstants.UNDO_DELETE_INSTANCE)

            spinner.stop();
        },100); 
    } 

    addInstancesToGrid(deletedInstances){

        const getIdByIndex = (index) =>{
           return $('#formInstancesGrid').find("tr").eq(index).attr("id");
        };

        _.each(deletedInstances, (instance) => {
            let row = getIdByIndex(instance.index);
            this.model.get("formInstances").push(instance.data.id);
            if (row){
                $('#formInstancesGrid').addRowData(instance.data.id, instance.data, "before", row);
            }else{
                $('#formInstancesGrid').addRowData(instance.data.id, instance.data);
            }
            $(`i[data-itemid*='${instance.data.id}']`).parent().show();
        });
    }
 
    restoreInstance(deletedInstances) {

        const formInstancesXML = this.model.get('formInstancesXML');
        const self = this;
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        RestService.unDeleteFormInstance(formInstancesXML).then((data) => {
           return (data);
        }).catch((error) => {
            let msg = error || 'Unknown Error';
            NotificationService.error(msg);
            console.log(msg);
            return (error);
        });

        setTimeout(function () {
            self.addInstancesToGrid(deletedInstances);
            spinner.stop();
        },100); 
    }
   

    closeModal() {
        $(this.El).remove();
    }

    render() {
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            $('body').append(this.$el);

            let self = this;
            let height = 'auto';            

            this.dialog = $(self.El).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: height,
                width: 450,
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'OK',
                        'class':'btn-select-field',                        
                        click: () => {                            
                            this.dialog.dialog( "close" );
                            resolve(self.deleteInstance());
                        }
                    },
                    {
                        text: 'Cancel',
                        'class': 'btn-addAssetCancel',
                        click: () => {
                            this.dialog.dialog("close");
                            this.closeModal();
                            reject('cancel');
                        }
                    }
                ],
                close: () => {
                    this.dialog.dialog("destroy");
                    this.closeModal();
                },
                open: () =>{
                   
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
            this.delegateEvents();
            return this;
        });
    }

}

export default ConfirmDeleteInstanceModal;
